// InputClonerObserver.js

import { InputClonerManager } from "../managers/InputClonerManager";

export class InputClonerObserver {
  constructor() {
    this.observer = new MutationObserver(this.handleMutations.bind(this));
    this.observeDocument();
    this.initializeExistingInputs();
  }

  observeDocument() {
    this.observer.observe(document.body, {
      childList: true,
      subtree: true, // Наблюдаем за всеми вложенными узлами
    });
  }

  handleMutations(mutationsList) {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          this.processNode(node);
        });
      }
    });
  }

  processNode(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    // Если добавленный узел сам является input
    if (node.matches('input')) {
      new InputClonerManager(node);
    }

    // Если добавленный узел содержит внутри себя input элементы
    node.querySelectorAll('input').forEach((input) => {
      new InputClonerManager(input);
    });
  }

  initializeExistingInputs() {
    document.querySelectorAll('input').forEach((input) => {
      new InputClonerManager(input);
    });
  }
}
